import type { FaireProductEntity } from "../../entity_types/product";

export const p_v7q3r5y8vn: FaireProductEntity = {
  token: "p_v7q3r5y8vn",
  type: "product",
  name: "Trefl Red Desert Moon 1000 Piece Puzzle",
  brandToken: "b_2gyr9m38qj",
  brandName: "Trefl USA",
  imageUrl:
    "https://cdn.faire.com/fastly/e25ddfca3f2b875dcdf6baf15648b988772b6db2740e27a658f2f34831b2c1a8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0f8c5f75fe709aea5a54e9f49a4db379b3e6d662a7ed3495dc697f36914cd35d.jpeg",
    "https://cdn.faire.com/fastly/0c78be5d4f0ef23659795438c05b45e6393eb8250826ac254e73fcd6347f4a37.jpeg",
    "https://cdn.faire.com/fastly/400a80fe9076ad7b8747e790fa31a93c3ebc371ea3900b71eb286584eff81be7.jpeg",
    "https://cdn.faire.com/fastly/67582677a2ca8bc12e2e7765d1623e255c83e5a6de65910fd6ae03aaba081044.jpeg",
  ],
  priceDollars: 6.91,
  description:
    "Watch the full moon rise over dunes of gold. Cacti cast long shadows across rippled sand as twilight deepens into indigo. Premium board and linen finish turn desert silence into striking wall art.",
  tags: [],
  msrpDollars: 13.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:26.547Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
